// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td.col-key-value .formatter-key-value-item[data-v-851f8a78]{padding:3px 0}td.col-key-value .formatter-key-value-item[data-v-851f8a78]:first-child{margin-top:10px}td.col-key-value .formatter-key-value-item[data-v-851f8a78]:last-child,td.col-key-value .formatter-key-value-item input[data-v-851f8a78],td.col-key-value .formatter-key-value-item textarea[data-v-851f8a78]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
